export function parseProcessSequence(value) {
  const parsed = Number(value);
  return Number.isInteger(parsed) && parsed >= 1 ? parsed : null;
}

export function sortProcessesForEndToEnd(processes) {
  const list = Array.isArray(processes) ? [...processes] : [];
  return list.sort((a, b) => {
    const sequenceA = parseProcessSequence(a?.sequence);
    const sequenceB = parseProcessSequence(b?.sequence);
    if (sequenceA == null && sequenceB == null) {
      const createdA = Date.parse(a?.created_at) || 0;
      const createdB = Date.parse(b?.created_at) || 0;
      return createdA - createdB;
    }
    if (sequenceA == null) return 1;
    if (sequenceB == null) return -1;
    if (sequenceA !== sequenceB) return sequenceA - sequenceB;
    const createdA = Date.parse(a?.created_at) || 0;
    const createdB = Date.parse(b?.created_at) || 0;
    return createdA - createdB;
  });
}

export async function fetchAllCycleProcesses(axiosInstance, getProcessesUrl, cycleId) {
  const pageSize = 100;
  const all = [];
  let page = 1;

  while (true) {
    const response = await axiosInstance.get(getProcessesUrl(cycleId), {
      params: { page, page_size: pageSize },
    });
    const batch = Array.isArray(response.data?.processes) ? response.data.processes : [];
    all.push(...batch);
    const pagesTotal = Number(response.data?.pagination?.total_pages) || 1;
    if (page >= pagesTotal || batch.length === 0) break;
    page += 1;
  }

  return all;
}
